/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
    string, shape, object, bool, func,
} from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import brandtheme from '../../../../components/AppShell/brandtheme';
import listItem from '../../common/Desktop/LeftMenuListItem';
import { getPassportPageUrl } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const MobileAccountHome = ({
    brandId, classes, userProfile, featureFlags, isShowSlider, history, toggleDrawer, passportUrl,
}) => {
    const baseURL = '/account';
    const currentUrl = typeof window !== 'undefined' ? window.location.pathname : '/';
    const brandIconColor = brandtheme[brandId]?.palette?.colorPrimary;
    const listItemData = listItem(brandIconColor, false);

    const getDataTestAttribute = (url) => url.replace(`${baseURL}${'/'}`, '').replace('/auth/logout', 'auth-logout');

    const handleListItemClicked = (url, regEx, userRole) => {
        if ((currentUrl !== url) && !(regEx?.test(currentUrl))) {
            if (userRole && (!userProfile?.passportStartDate || !userProfile?.passportEndDate || !userProfile?.passportFlag)) {
                return history.push(passportUrl);
            }
            history.push(url);
        } else {
            toggleDrawer();
        }
        return null;
    };

    return (
        <div className={isShowSlider ? classes.drawer : ''}>
            <h1 className={isShowSlider ? classes.accountHolderName : ''}>{userProfile.firstName}&apos;s Account</h1>
            <List
                component="nav"
                className={classes.root}
                data-test="my-account-options"
                aria-label="Account"
            >
                {listItemData.map((list) => {
                    if ((list.flag
                            && featureFlags[list.flag]
                            && featureFlags[list.flag] === 'N')
                    ) {
                        return '';
                    }
                    return (
                        <ListItem
                            key={list.id}
                            data-test={getDataTestAttribute(`${'my-account-option-'}${list.url}`)}
                            button
                            divider
                            onClick={() => handleListItemClicked(list.url, list.regEx, list.userRole)}
                            className={(currentUrl === list.url) || (list.regEx?.test(currentUrl))
                                ? `${classes.selectedUrl} padding-left-2x`
                                : 'padding-left-2x'}
                        >
                            <span className="margin-right">{list.icon}</span>
                            <ListItemText
                                className="flex-none margin-right"
                                primary={list.label}
                            />
                            {isShowSlider && <ArrowForwardIosIcon className="small margin-top-half" />}
                        </ListItem>
                    );
                })}
            </List>
        </div>
    );
};

MobileAccountHome.defaultProps = {
    history: {},
    userProfile: {},
    featureFlags: {},
    brandId: '',
    passportUrl: '',
};

MobileAccountHome.propTypes = {
    classes: object.isRequired,
    history: object,
    userProfile: shape({
        userRole: string.isRequired,
        email: string.isRequired,
        XAtt4: string, // some existing WCS users account don't have the XAttr attributes
        XAtt5: string,
    }),
    featureFlags: object,
    brandId: string,
    isShowSlider: bool.isRequired,
    toggleDrawer: func.isRequired,
    passportUrl: string,
};

const mapStateToProps = (state) => ({
    passportUrl: getPassportPageUrl(state),
});

const enhance = compose(
    connect(mapStateToProps),
);
export default enhance(MobileAccountHome);
